module.exports = __webpack_public_path__ + "static/media/closeCircle.cc43e5fd.svg";